"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsToggle = void 0;
const React = require("react");
const InlineOptions_1 = require("../InlineOptions");
/**
 * The idea behind the options toggle is that it'll act similar to an online options input,
 * however it may one take have transitions that differentiate from single inline options,
 * this is why it exists on its own.
 */
const OptionsToggle = ({ optionWidth = 150, options, optionCaptions, selected, onToggleSelected, className }) => {
    return (React.createElement(InlineOptions_1.SingleInlineOptions, { optionWidth: optionWidth, options: options, optionCaptions: optionCaptions, selected: selected, onSelection: onToggleSelected, className: className }));
};
exports.OptionsToggle = OptionsToggle;
//# sourceMappingURL=index.js.map